import React from "react"
import ChangePageBtn from "@components/common/changePageBtn"
import BlockHero from "@components/common/blockHero"
import Image from "@images/cartas/juan.png"
import Firma from "@images/cartas/firmaDirector.png"

const cartaDelDirectorGerente = () => {
  return (
    <div className="cartaDirector-container">
      <div className="element">
        <BlockHero>
          <div className="title">Zuzendari-gerentearen gutuna</div>
        </BlockHero>
      </div>
      <div className="element">
        <div className="content">
          <div className="blockImage">
            <div className="image-container">
              <div className="block">
                <div className="image">
                  <img src={Image} alt=""></img>
                </div>
              </div>
              <div className="block">
                <div className="blue_text">
                  “Ekitaldiak arrakasta objektiboa izan du, eta kudeatzeko eta
                  erreakzionatzeko gaitasunetik, ikuspegi estrategikotik eta
                  joera eta gertakariei etengabe aurrea hartzetik ulertzen dugu”
                </div>
              </div>
            </div>
            <div className="firma">
              <span>JUAN GÜELL UBILLOS</span>
              <span>Mutua Universal-eko Zuzendari Kudeatzailea</span>
            </div>
          </div>

          <div className="para">
            <p>
              2020. urtea COVID-19a bat-batean agertu zen urtea bezala
              gogoratuko dugu, mundu mailan aurrekaririk gabeko osasun, gizarte
              eta ekonomia larrialdi bat eragin zuen pandemiagatik. Pandemiaren
              ondorioak suntsitzaileak izan dira, bai gaixoen eta hildakoen
              kopuruei dagokienez, bai enpresen ekonomiari eta gizarte-geruza
              askoren pobretzeari dagokienez. Gaur egun, herrialde garatuenak
              benetan suspertzen ari diren arren, munduko leku askotan ezin izan
              da txertoa masiboki banatu, eta birusak aurrera egiten jarraitzen
              du, mutatzen, hondatzen eta jendea hiltzen. Beharrezkoa da, beraz,
              estatuak eta gizarteak guztiz ohartzea gaixotasun hau lurreko
              bazter guztietatik desagerrarazteko premia larriaz.
            </p>
            <p>
              Iaz, Espainiako ekonomiak % 11ko beherakada izan zuen, euroguneko
              handiena eta ELGAko handienetakoa. 2021ean, badirudi BPGaren
              susperraldi indartsua gertatuko dela (+% 6,4), baina ez da
              aurreikusten pandemiaren aurreko mailetara iristea 2022ko
              amaierara arte. Ekonomiaren kimu positibo horri bultzada argia
              eman dio Europar Batasunaren erantzunak: estrategiaz aldatu du
              krisialdi honetan eta estatu kideak suspertzeko pizgarri sorta bat
              eskaintzea aukeratu du, aurrekaririk gabea, hau ere.
            </p>
            <p>
              Gure lan-merkatuak, berez hauskorra izanda ere, atzerakada bat
              jasan zuen 622.600 langileren okupazioan (-% 3,1), Gobernuak hartu
              zituen, eta gizarte eragile guztien babesa jaso zuten
              euste-neurriak —batez ere, ABEEEak— gorabehera. Bestalde,
              langabezia-tasa % 16,13ra igo zen; BAIak 2012tik izan duen daturik
              txarrenarekin.
            </p>
            <p>
              2020ko martxoaren 14an, Diputatuen Kongresuak alarma-egoerari
              buruzko lehen dekretua onetsi zuen. Dekretu horrek tokiko,
              autonomia erkidegoko eta nazioarteko eremuetan egin zitezkeen
              mugimenduak mugatzea, biztanleriaren zati handi bat konfinatzea
              eta, horren ondorioz, zuzenean edo zeharka, sektore askoren
              enpresa-jarduera bertan behera uztea ezarri zuen. Behin-behineko
              neurri horiek eragin positiboa izan zuten kutsatze-erritmoari
              eusteko eta, horrekin batera, batzuetan mugara iritsi zen osasun
              sistema kolapsa ez zedin.
            </p>
            <p>
              Oso hilabete gogorrak izan ziren. Deskonfinamenduaren faseak
              kudeatzeko eta, ondoren, bigarren olatua sartu izana kudeatzeko,
              mutualitateok urte osoan zehar agertuz joan ziren egoera
              ezezagunei erantzuna emango zieten konponbideak bilatu genituen.
              Batzuetan, ordu gutxiren buruan erantzun behar izan genuen,
              betiere Gizarte Segurantzarekin eta Osasun Sistema Publikoekin
              lankidetza estuan.
            </p>
            <p>
              Memoria honetan adierazleen aukeraketa bat aurkezten da, urte oso
              zorrotz bati eraginkortasunez egokitu ginela erakusten duena.
              Tamainaren maila gizarte-prestazioen, eta Mutua Universalek
              egindako transferentzien eta dirulaguntzen gastuarekin egiazta
              daiteke. Gastu horrek % 83,83ko hazkundea izan zuen 2019ko
              ekitaldiarekin alderatuta (831,41 milioi euroraino iritsi zen);
              dena den, datuak ez du islatzen eskaera horri erantzuteko izan
              genituen konplexutasuna, azkartasuna eta baldintza murriztaileak.
            </p>
            <p>
              Ekitaldiak arrakasta objektiboa izan du, eta, gure ustez, bi
              ikuspuntu aintzat hartuz ulertu behar da:
            </p>
            <ul>
              <li>
                <span>Kudeatzeko eta erreakzionatzeko gaitasuna</span>, Mutua
                Universalek pandemiaren erronkari emandako erantzunarekin
                frogatu dena. Amaieran, jarduera oso azpimarragarri bat aurkeztu
                genuen, aurrekontu-oreka eta ia adierazle guztien hobekuntza
                islatzen dituena.
              </li>
              <li>
                <span>
                  Ikuspegi estrategikoa, eta joera eta gertakariei etengabe
                  aurrea hartzea
                </span>
                , berrikuntzaren, zorroztasunaren eta inbertsioaren bidez
                ongizatearen estatuaren jasangarritasunari laguntzeko dugun
                konpromisoari leial.
              </li>
            </ul>
          </div>
          <div className="blue_text center">
            “Helburu soziala duen eta irabazi-asmorik gabeko erakunde batean lan
            egitearen pribilegioa dugu, gizartearen ongizateari lagunduz,
            zorroztasun profesional eta kudeaketa-zorroztasun handienarekin”
          </div>
          <div className="para">
            <p>
              Egoerari eraginkortasunez heltzeko, beharrezkoak izan ziren
              talentu eta sakrifizio handiak, eta guztion lankidetza. Halaber,
              ezinbestekoa izan zen lehen mailako baliabide materialak eta
              teknologikoak izatea, bai eta kudeaketarako egitura arin bat ere,
              prozesuak berriz diseinatu eta ezartzeko. Zorionez, Mutua
              Universal denbora zeraman prestatzen. Erantzun azkarrak erakusten
              du aurreko urteetan norabide egokian joan ginela eta, ondorioz,
              sektoreko erakunderik bizkorrenetakoa eta eraginkorrenetakoa izan
              ginen gakoak izan ziren jarduketetan.
            </p>
            <p>
              Pandemia iritsi zenean, enpresa kaudimendun bat genuen, antolaketa
              eredu berritu bat eta teknologia-zuzkiduran eta ekipamenduan
              egindako inbertsio garrantzitsu batzuk genituen, eta horiei esker,
              talde konprometitu, trebatu eta solidario batek garai batean
              pentsaezinak irudituko zitzaizkigun lorpenak izan zituen.
            </p>
            <p>
              Egoera berri bakoitzari aurre egiteko dugun lasaitasunak Mutua
              Universaleko taldea definitzen eta bereizten du, bai lehenengo
              konfinamendura egokitzeko orduan, bai deskonfinamenduaren fase
              bakoitzaren plangintza eta garapen zehatza egiteko orduan, edo
              kutsatze-olatuen aurrean atzera egiteko orduan. Eta hori guztia,
              ziurgabetasun izugarri handiko esparru batean egin genuen.
            </p>
            <p>
              Helburu soziala duen eta irabazi-asmorik gabeko erakunde batean
              lan egitearen pribilegioa dugu, inguruan dugun gizartearen
              ongizateari lagunduz, zorroztasun profesional eta
              kudeaketa-zorroztasun handienarekin.
            </p>
            <p>
              Ohiz kanpokoa izan den urte baten errepasoa egiteko orduan, egoki
              deritzot Mutua Universaleko taldeko 1.883 emakume eta gizonei nire
              aintzatespenik handiena eskaintzeari. Euren sakrifizioarekin eta
              adimenarekin, lanpostu bakoitzean, herri bakoitzean eta egunero,
              erantzukizunaren, profesionaltasunaren eta elkartasunaren adibide
              izan dira.
            </p>
            <p>
              Hamarkada baten hasieran gaude, eta ziur asko garrantzi historikoa
              izango du, dakartzan mugarri eta aldaketa handiengatik. Europar
              Batasuneko estatuak ados jarri dira susperraldiaren ardatzak klima
              aldaketaren aurkako borroka, eta gizartearen eta ekonomiaren
              digitalizazioa izan daitezen.
            </p>
            <p>
              Eraginkorragoak izan nahi badugu eta Europako estatu sozialaren
              bideragarritasuna bermatu nahi badugu, eraldaketa digitalak gure
              bizitzako ia esparru guztietan duen benetako eraginaz jabetu behar
              gara. Teknologiak aldatu egin du harremanak izateko, lan egiteko,
              komunikatzeko, entretenitzeko, erosteko, informatzeko eta
              kudeatzeko modua… Eta, baita ere, pertsonen osasuna
              diagnostikatzeko, prebenitzeko eta zaintzeko modua. Dena den,
              eraldaketa fase horren hastapenetan gaude oraindik.
            </p>
            <p>
              Mutua Universal aitzindaria izan zen duela 20 urte baino gehiago
              Telemedikuntza garatzen, eta erabakitasunez eta lorpen zehatz oso
              garrantzitsuekin aurrera egiten jarraitzen dugu. Gaur egun, gure
              enpresa eta langile babestu guztiei (1,4 milioi baino gehiago)
              estaldura digitala emateko gai gara. Horrekin batera, dagoeneko
              errealitate bihurtzen hasi da irtenbide prediktiboen garapena,
              gure datu-base erraldoiari adimen artifiziala aplikatuz egiten
              dena. Pixkanaka garatzen eta hedatzen doan errealitatea da.
            </p>
            <p>
              Horrekin guztiarekin, babesten ditugun biztanleen ongizateari eta
              enpresen lehiakortasunari laguntzen jarraitzea espero dugu, bai
              eta Gizarte Segurantzarekiko lankidetza publiko-pribatuaren
              sistemaren iraunkortasunari ere. Optimismoz begiratzen diogu
              etorkizunari; hein handi batean, uste dugulako bultzatzen dugun
              disrupzio digitalak eragin oso positiboa izango duela sektorearen
              susperraldi ekonomikoan, zeinak berriz azpimarratu behar duen bere
              balioa, Administrazio Publikoari ekarpen garbia egiten dion
              sektore gisa.
            </p>
            <p>
              Urte hain konplexu honetan, aipamen berezia egin nahi diet
              Zuzendaritza Batzordeari eta, bereziki, haren presidenteari, Mutua
              Universalekiko erakutsi duten erabateko konpromisoagatik. Eta
              proiektu honek egunez egun aurrera egin dezan laguntzen diguten
              guztiei, bihotzez, eskerrak ematen dizkiet.
            </p>
            <div className="firma">
              <div className="image">
                <img src={Firma} alt=""></img>
              </div>
              <span>JUAN GÜELL UBILLOS</span>
              <span>Mutua Universal-eko Zuzendari Kudeatzailea</span>
            </div>
          </div>
        </div>
      </div>
      <div className="element changePage">
        <ChangePageBtn />
      </div>
    </div>
  )
}

export default cartaDelDirectorGerente
